// src/data/productData.js

// Markalar. Panelden ürün eklerken 'Marka' dropdown menüsü burayı okur.
// ID'ler küçük harf ve basit olmalı.
export const brands = [
  { id: 'asil', name: 'Asil' },
  { id: 'alveus', name: 'alveus' },
  { id: 'termikel', name: 'Termikel' },
  { id: 'emincelik', name: 'Eminçelik' },
  { id: 'white-daisy', name: 'White Daisy' },
  { id: 'mikroline', name: 'mikroline' },
  { id: 'teka', name: 'teka' },
  { id: 'ukinox', name: 'Ukinox' },
  { id: 'esty', name: 'esty' },
  { id: 'franke', name: 'Franke' },
  { id: 'sinkon', name: 'sinkon' },
  { id: 'gl-general', name: 'gl general' },
  // Buraya daha sonra yenileri eklenebilir
];

